<template>
  <base-modal 
    :is-open="!!reward" 
    modal-class="reward-modal"
    data-cy="reward-modal"
    @close="$emit('close')"
  >
    <ion-content v-if="reward" style="overflow: hidden;">
      <div class="p-lg text-center">
        <div class="text-[64px] text-primary mb-lg mt-md">
          <ion-icon :icon="iconMap[reward.icon as keyof typeof iconMap] || giftOutline"></ion-icon>
        </div>
        
        <h1 class="text-xl font-bold text-text-primary mb-sm" data-cy="modal-reward-name">{{ reward.name }}</h1>
        <p class="text-base text-text-secondary mb-lg" data-cy="modal-reward-description">{{ reward.description }}</p>
        
        <div class="flex justify-around mb-xl">
          <div class="flex flex-col" data-cy="modal-points-required">
            <span class="text-2xl font-bold text-primary">{{ reward.points_required }}</span>
            <span class="text-xs text-text-tertiary mt-xs">{{ $t('common.points') }}</span>
          </div>
          
          <div class="flex flex-col">
            <span class="text-2xl font-bold text-primary">{{ userPoints }}</span>
            <span class="text-xs text-text-tertiary mt-xs">{{ $t('common.totalPoints') }}</span>
          </div>
        </div>
        
        <div class="mb-8">
          <redeem-button
            :reward="reward"
            :is-affordable="isAffordable"
            :on-redeem="onRedeem"
            @close="$emit('close')"
          />
        </div>
        
        <div class="pt-lg border-t border-border text-left">
          <h3 class="text-sm font-semibold text-text-primary mb-0">{{ $t('rewards.termsAndConditions') }}</h3>
          <p class="text-xs text-text-tertiary">{{ $t('rewards.termsDescription') }}</p>
        </div>
      </div>

    </ion-content>
  </base-modal>
</template>

<script setup lang="ts">
import { IonContent, IonIcon } from '@ionic/vue';
import { giftOutline } from 'ionicons/icons';
import BaseModal from './BaseModal.vue';
import RedeemButton from './RedeemButton.vue';
import type { Reward } from '../types';

interface Props {
  reward: Reward;
  userPoints: number;
  isAffordable: (reward: Reward) => boolean;
  onRedeem: (reward: Reward) => void;
  iconMap: Record<string, string>;
}

defineProps<Props>();
defineEmits<{
  close: [];
}>();
</script> 